import myTraderaItemActions from './my-tradera-items';
import qs from 'qs';
import { checkStateOfQueryParams } from '../../helpers/route-helper';
import { setCookie } from './cookies';
import { selectCookiesState } from 'tradera-apps/my-tradera/app/state/reducers/cookies';
import { selectMyTraderaState } from 'tradera-apps/my-tradera/app/state/reducers/my-tradera';

//jshint module : true
const actionTypes = {
    SELECT_RADIO_BAR: 'SET_SELECTED_RADIO_BAR',
    GET_SEARCH: 'GET_SEARCH_RESULTS',
    SET_PAGE_SIZE: 'SET_PAGE_SIZE',
    CHANGE_SORT_VALUE: 'CHANGE_SORT_VALUE',
    CHANGE_TYPE_VALUE: 'CHANGE_TYPE_VALUE',
    CHANGE_SORT_ORDER: 'CHANGE_SORT_ORDER',
    CHANGE_SORTING_TO_BEST_MATCH: 'CHANGE_SORTING_TO_BEST_MATCH',
    SET_DATE_FROM: 'SET_DATE_FROM',
    SET_DATE_TO: 'SET_DATE_TO',
    CHANGE_PAGE: 'CHANGE_PAGE',
    CHANGE_SEARCH_QUERY: 'CHANGE_SEARCH_QUERY',
    CHANGE_RESERVATION_PRICE: 'CHANGE_RESERVATION_PRICE',
    RESET_FILTERS: 'RESET_FILTERS_TO_DEFAULT',
    SET_FILTERS_FROM_ROUTER: 'SET_FILTERS_BASED_ON_ROUTER',
    LOCATION_CHANGE: 'ROUTER_DISPATCHED_ROUTE_CHANGE',
    SET_FILTERS_FOR_PAGE: 'SET_FILTERS_BASED_ON_PAGE',
    SET_FILTERS_BY_STATE: 'SET_FILTERS_BASED_ON_STATE',
    SET_SINGLE_FILTER: 'SET_SINGLE_FILTER_VALUE',
    RESET_DATE_RANGE_TO: 'RESET_DATE_RANGE_TO',
    RESET_DATE_RANGE_FROM: 'RESET_DATE_RANGE_FROM',
    SHOW_HIDE_FILTERS: 'SHOW_HIDE_FILTER_TOOLBAR'
};

const updatePageSize = value => ({
    type: actionTypes.SET_PAGE_SIZE,
    payload: value
});

const setPageSize = value => dispatch => {
    dispatch(setCookie('ITEMS_PER_PAGE', value));
    dispatch(updatePageSize(value));
    return {
        type: actionTypes.setPageSize,
        payload: value
    };
};

const selectTypeChange = value => ({
    type: actionTypes.CHANGE_TYPE_VALUE,
    payload: value
});

const selectSortChange = (sort, sortOrder) => ({
    type: actionTypes.CHANGE_SORT_VALUE,
    payload: {
        sort: sort,
        sortOrder: sortOrder
    }
});

const changeSortingToBestMatch = (sort, sortOrder) => ({
    type: actionTypes.CHANGE_SORTING_TO_BEST_MATCH,
    payload: {
        sort: sort,
        sortOrder: sortOrder
    }
});

const setDateFrom = value => ({
    type: actionTypes.SET_DATE_FROM,
    payload: value
});

const setDateTo = value => ({
    type: actionTypes.SET_DATE_TO,
    payload: value
});

const changeSortOrder = () => ({
    type: actionTypes.CHANGE_SORT_ORDER
});

const changePage = value => ({
    type: actionTypes.CHANGE_PAGE,
    page: value
});

const changeSearchQuery = value => ({
    type: actionTypes.CHANGE_SEARCH_QUERY,
    payload: value
});

const selectReservationPriceChange = value => ({
    type: actionTypes.CHANGE_RESERVATION_PRICE,
    payload: value
});

const setFiltersFromRouter = params => ({
    type: actionTypes.LOCATION_CHANGE,
    payload: params
});

const updateFiltersForSelectedPage = filters => ({
    type: actionTypes.SET_FILTERS_FOR_PAGE,
    payload: filters
});

const setFiltersForSelectedPage = filters => (dispatch, getState) => {
    const pageSize = selectCookiesState(getState()).ITEMS_PER_PAGE;
    if (pageSize) {
        filters.newFilters.modifiers.paging.size = pageSize;
    }

    dispatch(updateFiltersForSelectedPage(filters));
};

const filterByState = value => ({
    type: actionTypes.SET_FILTERS_BY_STATE,
    payload: value
});

const setSingleFilterValue = (filter, value) => ({
    type: actionTypes.SET_SINGLE_FILTER,
    payload: {
        filter,
        value
    }
});

const historyLocationDidUpdate = history => (dispatch, getState) => {
    const isPrevAndCurrentPathnameEqual = () => {
        const routingState = getState().router;
        return (
            routingState.location &&
            routingState.location.pathname &&
            routingState.location.pathname === history.location.pathname
        );
    };

    const { location } = history;

    if (history.action === 'POP' && isPrevAndCurrentPathnameEqual()) {
        if (
            checkStateOfQueryParams(getState, location.search) &&
            selectMyTraderaState(getState()).isSearching === false
        ) {
            dispatch(
                setFiltersFromRouter(qs.parse(location.search.replace('?', '')))
            );
            dispatch(myTraderaItemActions.updateURL());
        }
    } else if (history.action === 'PUSH' && !isPrevAndCurrentPathnameEqual()) {
        if (
            checkStateOfQueryParams(getState, location.search) &&
            selectMyTraderaState(getState()).isSearching === false
        ) {
            dispatch(
                setFiltersFromRouter(qs.parse(location.search.replace('?', '')))
            );
            dispatch(myTraderaItemActions.updateURL());
        }
    }
};

const resetFilters = () => ({
    type: actionTypes.RESET_FILTERS
});

const resetDateRangeTo = () => ({
    type: actionTypes.RESET_DATE_RANGE_TO
});

const resetDateRangeFrom = () => ({
    type: actionTypes.RESET_DATE_RANGE_FROM
});

const showHideFilterToolbar = showCookies => dispatch => {
    dispatch(
        setCookie(
            'SHOW_FILTERS',
            showCookies === 'visible' ? 'hidden' : 'visible'
        )
    );
};

export default {
    actionTypes,
    resetDateRangeTo,
    resetDateRangeFrom,
    resetFilters,
    setPageSize,
    selectTypeChange,
    selectSortChange,
    changeSortingToBestMatch,
    setDateTo,
    setDateFrom,
    setSingleFilterValue,
    changeSortOrder,
    changePage,
    changeSearchQuery,
    updateFiltersForSelectedPage,
    selectReservationPriceChange,
    setFiltersFromRouter,
    setFiltersForSelectedPage,
    filterByState,
    updatePageSize,
    historyLocationDidUpdate,
    showHideFilterToolbar
};
